module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "point-of-origin"
    }
  }, [_c('h1', {
    staticClass: "main"
  }, [_vm._v("Point of Origin")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("There is nothing vast that enters into human life without a curse.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("—Sophocles "), _c('em', [_vm._v("Antigone")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-025fec64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 75
// module chunks = 0